import request from './request.js';

const userPageRequest = (params) => {
  return request({
    method: "POST",
    data: params,
    url: "/admin/user/search"
  })
}

const userAddRequest = (params) => {
  return request({
    method: "POST",
    data: params,
    url: "/admin/user"
  })
}

const userUpdateState = (params) => {
  return request({
    method: "PATCH",
    url: "/admin/user/state?username=" + params.username + "&valid=" + params.valid
  })
}

const userSubscriptionPageRequest = (params) => {
  return request({
    method: "POST",
    data: params,
    url: "/admin/user/subscription/page"
  })
}

const userAddSubscription = (params) => {
  return request({
    method: "POST",
    data: params,
    url: "/admin/user/subscription"
  })
}

const userUpdateSubscriptionState = (params) => {
  return request({
    method: "PATCH",
    url: "/admin/user/subscription/state?id=" + params.id + "&valid=" + params.valid
  })
}

const addSXWYYearRequest = (params) => {
  return request({
    method: "POST",
    data: params,
    url: "/SXWY/save/year"
  })
}

const getWatermark = () => {
  return request({
    method: "GET",
    url: "/admin/system/watermark"
  })
}

const updateWatermark = (params) => {
  return request({
    method: "POST",
    url: "/admin/system/watermark?watermark=" + encodeURI(params)
  })
}

export {
  addSXWYYearRequest, getWatermark, updateWatermark, userAddRequest, userAddSubscription, userPageRequest,
  userSubscriptionPageRequest, userUpdateState, userUpdateSubscriptionState
};

